import { useState, type FC, useContext, useCallback } from 'react'

import { useTheme } from '@emotion/react'

import styled from '@emotion/styled'

import { Button } from '@segment/matcha/components/Button/Button'

import * as views from '@segment/templates/FormSubmitAction/FormSubmitAction.views'

import FormSubmitMessage from '@segment/templates/FormSubmitMessage'

import { trackEmailCaptureForm } from '@segment/tracking/scripts'

import { DemoContext } from '@segment/contexts/demo'

import { BackgroundImage, ButtonWrapper, Description, Modal, ModalBody, ModalHead } from './Modal.views'

import imageCtaWrapperPng from './assets/ImageCtaWrapper.png'

const copy = {
  description: `Explore this interactive demo to see how Segment helps teams collect, clean, and activate data.`,
  buttonText: `Send me the tour`,
}

const thankYouMessage = {
  heading: `Check your inbox to begin the product tour.`,
  description: `For the best experience, we recommend viewing this demo on a desktop device.`,
}

export const MobileImageCta: FC = () => {
  const theme = useTheme()
  const [tourSent, setTourSent] = useState(false)
  const { completedFormData } = useContext(DemoContext)
  const onClickHandler = useCallback(async () => {
    await trackEmailCaptureForm({
      customFormIdentifier: `site-producttour-ungate`,
      ...completedFormData,
    })
    setTourSent(true)
  }, [completedFormData])

  const thankYouMessageComponent = (
    <StyledFormSubmitMessage
      form="demo"
      status="success"
      data-hook="demo-product-tour-sent-message"
      {...thankYouMessage}
    />
  )

  const cta = (
    <Wrapper>
      <BackgroundImage src={imageCtaWrapperPng} alt="Image Wrapper" />
      <Modal
        role="dialog"
        elevation={1}
        maxWidth={290}
        backgroundColor={theme.palette.neutrals.white[100]}
        sectionSeparatorColor={theme.palette.neutrals.white[100]}
      >
        <ModalHead></ModalHead>
        <ModalBody>
          <Description variant="textRegularSmall">{copy.description}</Description>
          <ButtonWrapper>
            <Button variant="filled" color="primary" size="medium" onClick={onClickHandler}>
              {copy.buttonText}
            </Button>
          </ButtonWrapper>
        </ModalBody>
      </Modal>
    </Wrapper>
  )
  return tourSent ? thankYouMessageComponent : cta
}

const StyledFormSubmitMessage = styled(FormSubmitMessage)`
  ${views.Header} {
    grid-template-columns: inherit;
  }
`

const Wrapper = styled.div`
  position: relative;
`
